<div class="m-4">
  <h2 class="mb-4" i18n="@@assign-driver-warning.assign-driver-warning">Tilldela</h2>
  <p class="mb-5" i18n="@@assign-driver-warning.assign-driver-warning-text">Föraren är redan tilldelat på körorder {{ assignedDriveOrderId }}, beställning {{ assignedOrderId}}. </p>

  <div class="d-flex">
    <button class="btn btn-outline-primary btn-min-width ms-auto me-2" id="dismissBtn" type="button" (click)="activeModal.dismiss()" i18n="@@assign-driver-warning.cancel">Avbryt</button>
    <button class="btn btn-primary btn-min-width" id="assignDriverBtn" type="button" (click)="assignDriver()" i18n="@@assign-driver-warning.assign">Tilldela</button>
  </div>
</div>
